import React, {Fragment} from 'react';
import CustomCss from "elements/custom-css/CustomCss";
import {connect} from "react-redux";
import {getCurrentRestaurantSelector, getCurrentServerConfig} from "../../../selectors";

export const CssDisplay = ({currentServerConfig, currentRestaurant}) => {
	return <Fragment>
		{currentServerConfig?.customCss && (
			<CustomCss url={currentServerConfig?.customCss} elementId="app-custom-css"/>
		)}
		{currentRestaurant?.customCssStyle && (
			<CustomCss url={currentRestaurant?.customCssStyle} elementId="custom-css"/>
		)}
	</Fragment>

}

const mapStateToProps = state => ({
	currentRestaurant: getCurrentRestaurantSelector(state),
	currentServerConfig: getCurrentServerConfig(state)
})

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CssDisplay);
